import { Flex, FormControl, FormErrorMessage, Select } from "@chakra-ui/react";

import areaArray from "@/assets/area_format_array.json";
import { useEffect, useState } from "react";
import AreaType from "./areatype";
type Area = {
  isRequired?: boolean;
  defaultProvince?: string;
  defaultCity?: string;
  defaultArea?: string;
  setProvice: React.Dispatch<React.SetStateAction<AreaType | undefined>>;
  setCity: React.Dispatch<React.SetStateAction<AreaType | undefined>>;
  setArea: React.Dispatch<React.SetStateAction<AreaType | undefined>>;
};

const DistPicker = (props: Area) => {
  const [city, setCity] = useState<AreaType[]>([]);
  const [area, setArea] = useState<AreaType[]>([]);

  const [pv, setPV] = useState(props.defaultProvince)
  const [cv, setCV] = useState(props.defaultCity)
  const [av, setAV] = useState(props.defaultArea)

  const province = areaArray.filter((area) => area.p == 0);

  useEffect(() => {
    if (props.defaultProvince) {
      const pv: AreaType = JSON.parse(props.defaultProvince);
      const c = areaArray.filter((area) => area.p == pv.i);
      setCity(c);
    }

    if (props.defaultCity) {
      const ct: AreaType = JSON.parse(props.defaultCity);
      const a = areaArray.filter((area) => area.p == ct.i);
      setArea(a);
    }
  }, [])

  const handleOnProviceSelect = (event: { target: { value: any } }) => {
    if (event.target.value) {
      setPV(event.target.value)
      const pv: AreaType = JSON.parse(event.target.value);
      const c = areaArray.filter((area) => area.p == pv.i);
      setCity(c);
      props.setProvice(pv);
    } else {
      setCity([]);
      setArea([]);
    }
  };
  const handleOnCitySelect = (event: { target: { value: any } }) => {
    if (event.target.value) {
      setCV(event.target.value)
      const ct: AreaType = JSON.parse(event.target.value);
      const a = areaArray.filter((area) => area.p == ct.i);
      setArea(a);
      props.setCity(ct);
    } else {
      setArea([]);
    }
  };
  const handleOnAreaSelect = (event: { target: { value: any } }) => {
    if (event.target.value) {
      setAV(event.target.value)
      const area: AreaType = JSON.parse(event.target.value);
      props.setArea(area);
    }
  };

  return (
    <Flex>
      <FormControl isRequired={props.isRequired}>
        <Select
          boxSizing="border-box"
          border="1px solid #DCE0EB"
          color={"#7F7F7F"}
          fontSize="14px"
          placeholder="请选择省"
          onChange={handleOnProviceSelect}
          value={pv}
        >
          {province.map((item, index) => (
            <option key={index} value={JSON.stringify(item)}>
              {item.n}
            </option>
          ))}
        </Select>
      </FormControl>

      <FormControl ml={"20px"} mr={"20px"} isRequired={props.isRequired}>
        <Select
          boxSizing="border-box"
          border="1px solid #DCE0EB"
          color={"#7F7F7F"}
          fontSize="14px"
          placeholder="请选择市"
          value={cv}
          onChange={handleOnCitySelect}

        >
          {city.map((item, index) => (
            <option key={index} value={JSON.stringify(item)}>
              {item.n}
            </option>
          ))}
        </Select>
        {
          props.isRequired &&
          <FormErrorMessage>该选项选择必填</FormErrorMessage>
        }
      </FormControl>

      <FormControl isRequired={props.isRequired}>
        <Select
          boxSizing="border-box"
          border="1px solid #DCE0EB"
          color={"#7F7F7F"}
          fontSize="14px"
          placeholder="请选择区"
          value={av}
          onChange={handleOnAreaSelect}
        >
          {area.map((item, index) => (
            <option key={index} value={JSON.stringify(item)}>
              {item.n}
            </option>
          ))}
        </Select>
        {
          props.isRequired &&
          <FormErrorMessage>该选项选择必填</FormErrorMessage>
        }
      </FormControl>

    </Flex>
  );
};

export default DistPicker;
